import React from 'react'

const Footer = () => (
    <p style={styles.para}>Copyright &copy; {new Date().getFullYear()}. All rights reserved.</p>
)

export default Footer

const styles = {
    para: {
        textAlign: 'center',
        color: '#767676',
        fontSize: '0.8rem'
    }
}


// WEBPACK FOOTER //
// ./src/components/Footer.js